import type { ShichuPart } from '../lib/types';
import { StarRating } from './StarRating';
import { CategoryGrid } from './CategoryGrid';
import { SourceFooter } from './SourceFooter';

interface Props {
  data: ShichuPart;
}

export function ShichuCard({ data }: Props) {
  return (
    <section className="card mt-4 mx-4">
      <header className="flex items-baseline gap-3">
        <span className="label">第2部</span>
        <h2 className="card-title">四柱推命</h2>
      </header>
      <div className="mt-2 flex items-center gap-3">
        <StarRating value={data.rating} label={data.ratingLabel} />
      </div>

      {data.tsuhenseiTable.length > 0 && (
        <div className="mt-4 -mx-1 overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="text-ink-400 dark:text-ink-300 border-b border-ink-200/50 dark:border-ink-700/50">
                <th className="text-left font-medium py-1 pl-1 pr-2">日付</th>
                <th className="text-left font-medium py-1 px-2">干支</th>
                <th className="text-left font-medium py-1 px-2">通変星</th>
                <th className="text-left font-medium py-1 px-2">意味</th>
              </tr>
            </thead>
            <tbody>
              {data.tsuhenseiTable.map((r, i) => (
                <tr key={i} className="border-b border-ink-100/60 dark:border-ink-800/60 last:border-0">
                  <td className="py-1.5 pl-1 pr-2 text-ink-500 dark:text-ink-300 whitespace-nowrap">{r.date}</td>
                  <td className="py-1.5 px-2 font-serif text-ink-700 dark:text-ink-100">{r.kanshi}</td>
                  <td className="py-1.5 px-2 text-gold-500 font-medium whitespace-nowrap">{r.tsuhensei}</td>
                  <td className="py-1.5 px-2 text-ink-600 dark:text-ink-200">{r.meaning}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <CategoryGrid categories={data.categories} />
      <SourceFooter sources={data.sources} />
    </section>
  );
}
